(function() {
	// test for pointer-events support
	var element = document.createElement('x');
		element.style.cssText = 'pointer-events:auto';
		if (element.style.pointerEvents !== 'auto') {
			document.documentElement.classList.add('no-pointerevents');
		} 

	// test for proper fixed support
	if (!(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)) {
		document.documentElement.classList.add('fixed');
	} else {
		document.documentElement.classList.add('no-fixed');		
	}
})();

function canUseWebP() {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }

    // very old browser like IE 8, canvas not supported
    return false;
}